import { useCallback, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { useI18n } from 'builder/hooks/useI18n'
import ModalOverlay from 'builder/components/ModalOverlay'
import { DocumentTypes } from 'builder/modules/constants'
import { ALLOWED_FILES } from 'builder/components/FillResumeModal/constants'
import { actions as panelActions } from 'builder/modules/panel'
import { FileInput } from 'builder/components/PhotoUploadField/styles'
import { LOCALIZATION_KEY_VER_4 } from '../../constants'
import {
  Container,
  HeaderContainer,
  Title,
  SubTitle,
  OptionsContainer,
  CardContainer,
  IconWrapper,
  IconUpload,
  CardContentWrapper,
  CardTitle,
  CardSubTitle,
  DividerContainer,
  DividerText,
  IconCreate,
  CloseIconWrapper,
  CloseIcon,
} from './styles'

type Props = {
  handleUploadClick: (event: React.MouseEvent<HTMLInputElement>) => void
  handleFileInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onClose: () => void
}

const LANGUAGE_KEY = `${LOCALIZATION_KEY_VER_4}.welcome_screen.resume_select_modal`

export const ResumeSelectModal = (props: Props) => {
  const { i18n } = useI18n()
  const dispatch = useDispatch()
  const containerRef = useRef<HTMLDivElement>(null)
  const { handleUploadClick, handleFileInputChange, onClose } = props

  const handleCreateResume = useCallback(() => {
    dispatch(
      panelActions.createDocument({
        type: DocumentTypes.resume,
        isResumeDistributionCreateAction: true,
      }),
    )
  }, [dispatch])

  return (
    <ModalOverlay onClick={onClose} overlayFadeDuration={150} contentSlideDuration={150}>
      <Container ref={containerRef}>
        <CloseIconWrapper onClick={onClose}>
          <CloseIcon />
        </CloseIconWrapper>
        <HeaderContainer>
          <Title>{i18n.t(`${LANGUAGE_KEY}.title`)}</Title>
          <SubTitle>{i18n.t(`${LANGUAGE_KEY}.subtitle`)}</SubTitle>
        </HeaderContainer>
        <OptionsContainer>
          <CardContainer htmlFor="file-resume-upload">
            <IconWrapper>
              <IconUpload />
            </IconWrapper>
            <CardContentWrapper>
              <CardTitle>{i18n.t(`${LANGUAGE_KEY}.options.upload_resume.title`)}</CardTitle>
              <CardSubTitle>
                {i18n.t(`${LANGUAGE_KEY}.options.upload_resume.subtitle`)}
              </CardSubTitle>
            </CardContentWrapper>
            <FileInput
              type="file"
              onClick={handleUploadClick}
              onChange={handleFileInputChange}
              accept={ALLOWED_FILES}
              id="file-resume-upload"
            />
          </CardContainer>
          <DividerContainer>
            <DividerText>{i18n.t(`${LANGUAGE_KEY}.options.divider_text`)}</DividerText>
          </DividerContainer>
          <CardContainer onClick={handleCreateResume}>
            <IconWrapper>
              <IconCreate />
            </IconWrapper>
            <CardContentWrapper>
              <CardTitle>{i18n.t(`${LANGUAGE_KEY}.options.create_resume.title`)}</CardTitle>
              <CardSubTitle>
                {i18n.t(`${LANGUAGE_KEY}.options.create_resume.subtitle`)}
              </CardSubTitle>
            </CardContentWrapper>
          </CardContainer>
        </OptionsContainer>
      </Container>
    </ModalOverlay>
  )
}
